import http from "utils/http"

const placeOrder = payload => http.post("/order/v1/order/", payload)

const getOrderStatus = idOrder => http.get(`/order/v1/order/${idOrder}/status`, undefined, undefined, true, true)

const getCampaignRate = () => http.get(`/order/v1/order/campaingrate/`)

const getOrder = idOrder => http.get(`/order/v1/order/${idOrder}`)

const getInvoiceInfo = invoiceNumber => http.get(`/order/v1/invoice/invoiceinfo/${invoiceNumber}`)

const getInvoiceStatus = invoiceNumber => http.get(`/order/v1/invoice/invoicestatus/${invoiceNumber}`)

const getPendingFeedback = idAddress =>
  idAddress
    ? http.get(`/order/v1/order/feedback/pending/address/${idAddress}`)
    : http.get('/order/v1/order/feedback/pending')

const submitFeedback = payload => http.post('/order/v1/order/feedback', payload)

const skipFeedback = payload => http.post('/order/v1/order/feedback/skip', payload)

export default {
  placeOrder,
  getOrderStatus,
  getCampaignRate,
  getOrder,
  getInvoiceInfo,
  getInvoiceStatus,
  getPendingFeedback,
  submitFeedback,
  skipFeedback
}



// WEBPACK FOOTER //
// ./src/services/orderService.js